module.exports = __webpack_public_path__ + "img/dummyimg.f3556f3b.jpg";